import { Button } from '@/components/ui/button'
import { FileUp, Trash2 } from 'lucide-react'
import { useState } from 'react'
import type { AnswerInputProps } from '../QuestionRenderer'

export function FileUploadInput({ value = [], onChange }: AnswerInputProps<string[]>) {
  const [dragging, setDragging] = useState(false)

  function add(files: FileList | null) {
    if (!files) return
    const uploaded = Array.from(files).map((file) => `mock-r2://${file.name}`)
    onChange([...value, ...uploaded])
  }

  return (
    <div className="flex flex-col gap-3">
      <label
        onDragOver={(event) => {
          event.preventDefault()
          setDragging(true)
        }}
        onDragLeave={() => setDragging(false)}
        onDrop={(event) => {
          event.preventDefault()
          setDragging(false)
          add(event.dataTransfer.files)
        }}
        className={`grid min-h-40 cursor-pointer place-items-center rounded-lg border border-dashed p-6 text-center ${
          dragging ? 'border-indigo-500 bg-indigo-50' : 'border-slate-300 bg-white'
        }`}
      >
        <input
          type="file"
          multiple
          className="hidden"
          onChange={(event) => add(event.target.files)}
        />
        <div>
          <FileUp className="mx-auto size-9 text-indigo-600" />
          <div className="mt-3 font-medium">拖放檔案或點擊上傳</div>
          <div className="mt-1 text-sm text-slate-500">
            目前為 mock R2 URL，API scaffold 已保留上傳端點。
          </div>
        </div>
      </label>
      {value.map((file) => (
        <div
          key={file}
          className="flex items-center justify-between rounded-md border border-slate-200 bg-white p-3 text-sm"
        >
          <span>{file.replace('mock-r2://', '')}</span>
          <Button
            variant="ghost"
            size="icon"
            onClick={() => onChange(value.filter((item) => item !== file))}
          >
            <Trash2 className="size-4" />
          </Button>
        </div>
      ))}
    </div>
  )
}
